.sectionHeader {
  display: flex;
  flex-direction: column;
  gap: var(--pgm-sys-spacing-6);
}

.ornament {
  background-color: var(--pgm-sys-color-brand-primary);
  border-radius: 8px;
  display: block;
  height: 8px;
  width: 80px;
}

.texts {
  display: flex;
  flex-direction: column;
  gap: var(--pgm-sys-spacing-2);
  padding: var(--pgm-sys-spacing-2) 0;
}

.label {
  color: var(--pgm-sys-color-primary);
  margin: 0;
  text-transform: uppercase;
}

.title {
  color: var(--pgm-sys-color-on-surface-variant);
  margin: 0;
}
